import {useTranslation} from "react-i18next";
import {useNotification} from "./notification/NotificationProvider";


const useApiNotification = () => {
    const context = useNotification();
    const {t} = useTranslation();

    const showSuccess = (msg?: string) => {
        context.pushNotification({message: msg ? msg : t('_Common.Api.Messages.SaveSuccessful'), severity: 'success'});
    };

    const handleError = (err: any): number => {
        console.error(err, err.response);
        let msg = '_Common.Api.Messages.UnknownError';
        if (err.response && err.response.data && err.response.data.error)
            msg = `_Common.Api.Messages.${err.response.data.error.type}`;
        return context.pushNotification({message: err.customMessage || t(msg), severity: 'error'});
    };

    const handleErrors = (err: string[], initialErrorMsgKey: string): number => {
        console.error(err);
        let msg = '_Common.Api.Messages.UnknownError';
        if (err.length > 0)
            msg = err.reduce((errs, e) => `${errs}\n${t(`_Common.Api.Messages.${e}`)}`, `${t(initialErrorMsgKey)}`);

        return context.pushNotification({message: msg, severity: 'error'});
    };


    return {
        ...context,
        showSuccess,
        handleError,
        handleErrors
    };
};


export {useApiNotification};
